import Repository from "./Repository";
import DocumentCategoriesResponse from "./response/DocumentCategoriesResponse";
import Axios from "axios";
import Document from "../types/Document";
import DocumentCategory from "../types/DocumentCategory";
import DocumentResponse from "./response/DocumentResponse";
import BaseResponse from "../types/BaseResponse";

const resource = "/document";

export default {
  get(companyId: string, type: string, activeOnly: boolean) {
    return Repository.get<BaseResponse<Document[]>>(
      `${resource}/type/${companyId}/${type}?activeOnly=${activeOnly}`
    );
  },
  getOne(documentId: string) {
    return Repository.get<DocumentResponse>(`${resource}/${documentId}`);
  },
  getCategories(companyId: string) {
    return Repository.get<DocumentCategoriesResponse>(
      `${resource}/category/company/${companyId}`
    );
  },
  getByEmployee(employeeId: string, type: string) {
    return Repository.get(
      `${resource}/employee/${employeeId}?documentType=${type}`
    );
  },
  getUrl(documentId: string) {
    return Repository.get(`${resource}/${documentId}/documentUrl`);
  },
  addCategory(companyId: string, documentId: string, categoryId: string) {
    return Repository.post(`${resource}/category/${categoryId}/addDocument`, {
      companyId,
      documentId,
      categoryId,
    });
  },
  addCategories(companyId: string, documentId: string, categoryIds: string[]) {
    let reqs: any = [];
    for (let id of categoryIds) {
      reqs.push(this.addCategory(companyId, documentId, id));
    }
    return Axios.all(reqs);
  },
  request(data: any) {
    return Repository.post(`${resource}`, data);
  },
  upload(documentId: string, data: FormData) {
    return Repository.post(`${resource}/upload/${documentId}`, data);
  },
  download(documentId: string) {
    Repository.get(`${resource}/${documentId}/download`, { responseType: 'blob'})
    .then((response) => {
      let contentDispositionHeaderParts = response.headers["content-disposition"].split(";")
      let fileNamePart = contentDispositionHeaderParts[1]
      let fileNameRaw = fileNamePart.split("=")
      let fileName = fileNameRaw[1].replaceAll("\"", "")
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    });
  },
  addToEmployee(companyId: string, documentId: string, employeeId: string) {
    return Repository.post(`${resource}/${documentId}/employee`, {
      companyId,
      documentId,
      employeeId,
    });
  },
  addToGroup(companyId: string, documentId: string, employeeGroupId: string) {
    return Repository.post(`${resource}/${documentId}/employeeGroup`, {
      companyId,
      documentId,
      employeeGroupId,
    });
  },
  save(document: Document) {
    if (document.documentId) {
      return Repository.patch(`${resource}/${document.documentId}`, document);
    } else {
      return Repository.post(`${resource}`, document);
    }
  },
  saveAll(documents: Document[]) {
    let reqs: any = [];
    for (let document of documents) {
      reqs.push(this.save(document));
    }
    return Axios.all(reqs);
  },

  updateDocumentStatus(documentIds: String[], isActive: boolean) {
    return Repository.post(
      `${resource}/updateDocuments?isActive=${isActive}`, documentIds
    );
  },

  seedDefaultCategories(companyId: string) {
    return Repository.post(
      `${resource}/category/${companyId}/defaultCategories`
    );
  },
  saveCategory(category: DocumentCategory) {
    if (category.categoryId) {
      return Repository.patch(`${resource}/category`, category);
    } else {
      return Repository.post(`${resource}/category`, category);
    }
  },
  saveAllCategories(categories: DocumentCategory[]) {
    let reqs: any = [];
    for (let c of categories) {
      reqs.push(this.saveCategory(c));
    }
    return Axios.all(reqs);
  },
  getForGroup(groupId: string) {
    return Repository.get<BaseResponse<Document[]>>(
      `${resource}/employeeGroup/${groupId}`
    );
  },
};
